import { CircularProgress } from '@mui/material'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { AcUnit, TruckSpeedOutlined } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { Tooltip } from '@pets-ui/Tooltip/Tooltip'
import * as stylex from '@stylexjs/stylex'
import { formatPrice } from '@utils'

const style = stylex.create({
  tooltip: {
    minWidth: 200,
  },
})

const progressStyle = {
  '&.MuiCircularProgress-root': {
    borderRadius: 12,
    color: colors.green400,
  },
}

interface FreeShippingTipsProps {
  currency?: string
  isFree?: boolean
  isFrozenFullBox?: boolean
  isNormalShipping?: boolean
  leftAmount: number
  percentage: number
  tooltipText?: string
}

export function FreeShippingTips({ currency, isFree, isFrozenFullBox, isNormalShipping, leftAmount, percentage, tooltipText }: FreeShippingTipsProps) {
  const covertPercentage = percentage * 100 > 100 ? 100 : percentage * 100
  const isFreeShipping = covertPercentage >= 100 || isFree

  const TooltipText = <Text variant="caption">{tooltipText}</Text>

  return (
    <Tooltip key={tooltipText} title={TooltipText} placement="top" paperStyle={style.tooltip}>
      <Box display="flex" alignItems="center">
        <HStack gap={1} backgroundColor={isFreeShipping ? colors.green400 : colors.yellow600} borderRadius={12} padding="2px 20px 2px 8px" display="flex" alignItems="center" justifyContent="center" height={20} marginRight={-4}>
          <FreeShippingTipsWithText isFreeShipping={isFreeShipping} isFrozenFullBox={isFrozenFullBox} currency={currency} leftAmount={leftAmount} />
        </HStack>
        <Box position="relative" display="inline-flex">
          <Box width={28} height={28} borderRadius="50%" backgroundColor={colors.white} display="flex" alignItems="center" justifyContent="center">
            {
              (!isFrozenFullBox || isFreeShipping)
              && <CircularProgress sx={progressStyle} variant="determinate" value={isFreeShipping ? 100 : covertPercentage} size={24} />
            }
            <Box position="absolute" top={0} left={0} right={0} bottom={0} display="flex" alignItems="center" justifyContent="center">
              {
                isNormalShipping
                  ? <TruckSpeedOutlined fontSize={16} />
                  : <AcUnit fontSize={16} />
              }
            </Box>
          </Box>
        </Box>
      </Box>
    </Tooltip>
  )
}

interface FreeShippingTipsWithTextProps {
  isFreeShipping?: boolean
  isFrozenFullBox?: boolean
  currency?: string
  leftAmount?: number
}

const FreeShippingTipsWithText = ({ isFreeShipping, isFrozenFullBox, currency, leftAmount }: FreeShippingTipsWithTextProps) => {
  const leftAmountToInteger = Math.round(leftAmount ?? 0)
  if (isFreeShipping) {
    return <Text variant="caption">已達免運</Text>
  }
  else if (isFrozenFullBox) {
    return <Text variant="caption">固定運費，整數箱免運</Text>
  }
  else {
    return (
      <Text variant="caption">
        {formatPrice(currency, leftAmountToInteger, '再消費 $value免運')}
      </Text>
    )
  }
}
